import { authServiceApi } from "../../../app/authServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../types";
import {
  GetDashboardDataParamsType,
  GetDashboardDataResponse,
} from "./dashboard.type";

export const notificationApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardData: builder.query<
      CommonResponse<GetDashboardDataResponse>,
      GetQueryArgsType<GetDashboardDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardData,
        ...queryArgs,
      }),
      providesTags: ["GetDashboardData"],
    }),
  }),
});

export const { useGetDashboardDataQuery } = notificationApi;
